import React from "react";
import { Heart } from "lucide-react";
import { useCustomerAuth } from "@/contexts/CustomerAuthContext";

// Heart toggle for saving/unsaving a project. Works from project cards (inside
// a <Link>, so clicks must be stopped from bubbling to the navigation) and
// from the project detail page. Prompts Google login if not signed in yet.
export default function FavoriteButton({ slug, className = "" }) {
  const { favoriteSlugs, toggleFavorite } = useCustomerAuth();
  const isFav = favoriteSlugs?.has(slug);

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    toggleFavorite(slug);
  };

  return (
    <button
      onClick={handleClick}
      data-testid={`favorite-btn-${slug}`}
      aria-label="Favorit"
      aria-pressed={isFav}
      className={`w-10 h-10 shrink-0 flex items-center justify-center backdrop-blur-md border transition-colors ${
        isFav
          ? "bg-white text-[#051630] border-white"
          : "bg-white/10 text-white border-white/25 hover:border-white"
      } ${className}`}
    >
      <Heart size={16} strokeWidth={1.5} fill={isFav ? "currentColor" : "none"} />
    </button>
  );
}
